/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, May 3, 2018
 * For information or permission request, email info@aetonixsystems.com
 */

import par from "par";

import defineUI from "../shared/define";
import render from "./render.jsx";
import PersonStore from "../stores/person_store";
import OrgStore from "../stores/org_store";
import WorkflowStore from "../stores/admin_workflow_store";
import LocalizationStore from "../stores/localization_store";
import CurrentPersonInfoStore from "../stores/current_person_info_store";
import CareplanNotificationStore from "../stores/careplan_notice_store";
import ConnectionStore from "../stores/connection_store";
import ResourcesStore from "../stores/admin_resources_store";
import FormsStore from "../stores/admin_forms_store";
import AdminOrgStore from "../stores/admin_org_store";
import OptionStore from "../stores/admin_options_schema_store";
import makeStoreFactory from "../shared/stores";

const makeStores = makeStoreFactory({
	orgs: OrgStore,
	allOrgs: AdminOrgStore,
	people: PersonStore,
	workflow: WorkflowStore,
	currentPerson: CurrentPersonInfoStore,
	localization: LocalizationStore,
	careplanChangeList: CareplanNotificationStore,
	connection: ConnectionStore,
	forms: FormsStore,
	resources: ResourcesStore,
	options: OptionStore
});

export default make_ui;

function make_ui(api, events, config, userMetrics) {
	var storeStore = makeStores(api, events, config);

	window.stores = storeStore.store;

	userMetrics.trackEvent("page view", {
		"page": "admin-workflow",
		"category": "admin",
		"permission level": "admin",
	});

	return defineUI({
		getInitialState: getInitialState,
		componentDidMount: listen_for_changes,
		render: render,
		componentWillUnmount: removeListeners
	});

	function removeListeners() {
		events.off();
	}

	function listen_for_changes() {
		storeStore.listen(par(handle_change, this));
	}

	function getInitialState() {
		return {
			orgs: [],
			allOrgs: [],
			loadMore: par(loadMore, storeStore.stores.orgs),
			people: storeStore.stores.people,
			workflow: storeStore.stores.workflow,
			currentPerson: storeStore.stores.currentPerson,
			localization: storeStore.stores.localization,
			searchOrg: par(searchOrg, storeStore.stores.orgs),
			careplanChangeList: storeStore.stores.careplanChangeList,
			connection: storeStore.stores.connection,
			forms: [],
			resources: [],
			updating: false,
			creating: false,
			schemaError: false,
			addWorkflow: addWorkflow,
			updateWorkflow: updateWorkflow,
			removeWorkflow: removeWorkflow,
			duplicateWorkflow,
			options: storeStore.stores.options,
			isDuplicating: false,
			duplicateOrg: "",
			errorToast: false,
			openToast: false,
			inProgressToast: false,
			toastMessage: "",
			isMissingDestination: false,
			userMetrics: userMetrics,
		};
	}

	function duplicateWorkflow(workflow, org, destination) {
		return api.admin.workflow.duplicate(workflow, org, destination);
	}

	function searchOrg(orgs, event) {
		event.persist();
		var query = event.target.value;
		return orgs.search(query);
	}

	function loadMore(orgs) {
		return orgs.more();
	}

	function handle_change(component, stores) {
		component.setState({
			orgs: stores.orgs.all(),
			allOrgs: stores.allOrgs.all(),
			people: stores.people,
			workflow: stores.workflow,
			currentPerson: stores.currentPerson,
			localization: stores.localization,
			careplanChangeList: stores.careplanChangeList,
			connection: stores.connection,
			forms: stores.forms,
			resources: stores.resources,
			options: stores.options
		});
	}


	function addWorkflow(workflow, viewing) {
		var icon = workflow.icon;
		var schema = workflow.schema;
		if (!icon || !schema) {
			return;
		}
		return api.admin.workflow.create(workflow, viewing);
	}

	function updateWorkflow(workflow, viewing) {
		var workflowId = workflow._id;
		var icon = workflow.icon;
		var schema = workflow.schema;
		var organization = workflow.organization;

		if (organization !== viewing) return;

		if (!icon || !schema) {
			return;
		}

		return api.admin.workflow.update(workflowId, workflow, organization);
	}

	function removeWorkflow(workflow, viewing) {
		var workflowId = workflow._id;
		var organization = workflow.organization;
		if (organization !== viewing) return;
		return api.admin.workflow.remove(workflowId, organization);
	}

}
